export class CompanyInsiderReq {
  public companyId: string;
  public insiderId: string;
  public phoneNumber: string;
  public isAdmin: boolean;
}
